import React from "react";
import { FallingLines } from "react-loader-spinner";

const Bar = () => {
  return (
    <FallingLines
      height="50"
      width="45"
      color="#67748b"
      ariaLabel="falling-circles-loading"
      visible={true}
    />
  );
};

export default Bar;
